<template lang="html">
  <div class="shopify-create-store">
    <Guide
      width="small"
      :content="content"
      contentHeading="Select/Create An Account"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsSelectAccount',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'analytics-admin',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'analytics-create-property',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>Click on the <strong>Account</strong> dropdown and select the account under which you would like to add a new website.</p>

          <div class="helper-text">
            <p>Alernatively, you can create a new account by clicking the <strong>+ Create Account</strong> button.</p>
          </div>
        `
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
